import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../../../_services/user.service';
import { ValidateEmailService } from '../../../../_services/signup-process-service/validate-email.service';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { Router , RouterModule } from '@angular/router';
import { EmailService } from '@services/email/email.service';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';
import { Meta } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-validate-account-email-phone',
  templateUrl: './validate-account-email-phone.component.html',
  styleUrls: ['./validate-account-email-phone.component.scss'],
})
export class ValidateAccountEmailPhoneComponent implements OnInit, OnDestroy{
  email: any;
  user_detail: any = [];
  isAcmic = false;
  utmQueryParams: { [key: string]: string; };
  constructor(
    private _userService: UserService,
    private alertService: AlertService,
    private validateEmailService: ValidateEmailService,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService: AcmicService,
    private router: Router,
    private emailService: EmailService,
    private paramHandlingService: ParamHandlingService,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.meta.addTag({ name: 'robots', content: 'noindex' });
    this.isAcmic = this.acmicService.isACMIC();
    this.user_detail = this._userService.getUserInfoInStorage();
    if (this.user_detail) {
      this.email = this.emailService.maskEmail(this.user_detail['userDetails']['email']);
    }
    this.utmQueryParams =  this.paramHandlingService.getUtmQueryParams();
  }
  sendEmail() {
    const emailId = this.user_detail['userDetails']['email'];
    // Call sendValidationEmail for send Resent Verification mail form user email address
    this.validateEmailService
      .sendValidationEmailForNonCommercial(emailId)
      .subscribe(
        (resp) => {
          if (resp) {
            this.alertService.success('VERIFICATION_EMAIL_SENT');
            if(this.isAcmic && Object.keys(this.utmQueryParams).length ) {
              this.router.navigate(['/signup', 'validate-account'], { queryParams: this.utmQueryParams, queryParamsHandling: 'merge'});
            } else {
              this.router.navigate(['/signup', 'validate-account']);
            }
          }
        },
        (error) => {
          this.errorRedirectionService.errorHandler(
            error,
            'VERIFICATION_EMAIL_ERROR'
          );
        }
      );
  }

  validateMobile(): void {
    this.router.navigate(['/signup', 'validate-phone']);
  }

  ngOnDestroy(): void {
    this.meta.removeTag('name="robots"');
  }
}
